import type { Me, StaffModuleKey } from '@briary/shared'
export function canUseStaffModule(me: Me | null, key: StaffModuleKey): boolean {
  return !!me && (me.isSuperadmin || (me.areas.includes('admin') && me.staffModules?.[key] === true))
}
export function canOpenStaffPath(me: Me | null, path: string): boolean {
  return !/^\/admin\/operations(?:\/|$)/.test(path) || canUseStaffModule(me, 'operations')
}
